module.exports = __webpack_public_path__ + "static/media/da.07be1277.svg";